<template>
    <div class="bg"></div>
    <div class="bg bg2"></div>
    <div class="bg bg3"></div>
    <div class="content">
        <header class="brand-header">
            <img :src="logoSrc" alt="Inovanex" class="brand-logo" />
            <div class="brand-text">
                <h1 class="brand-title">Generador Player Radio <span class="brand-version">v3</span></h1>
                <p class="brand-by">by <a href="https://inovanex.com" target="_blank" rel="noopener">INOVANEX.COM</a></p>
            </div>
        </header>
        <details class="instrucciones">
            <summary>¿Cómo funciona? — Guía rápida</summary>
            <ol>
                <li>Elegí el modelo del reproductor: <b>Slim</b>, <b>Vertical</b> o <b>Minimal</b>.</li>
                <li>Seleccioná <b>Radio Única</b> o <b>Multi Radio</b> según el caso.</li>
                <li>Completá nombre, eslogan, imagen de portada y URL del streaming principal.</li>
                <li>Opcional: agregá streamings de backup, enlace de metadata y de programación.</li>
                <li>Elegí los dos colores (tema y texto) y la fuente.</li>
                <li>Hacé clic en <b>Generar Reproductor</b>.</li>
                <li>Copiá el código <code>&lt;iframe&gt;</code> que aparece al final y pegalo en tu sitio.</li>
            </ol>
        </details>
        <div class="form">
            <FormGenerator />
        </div>
        <footer class="brand-footer">
            <p>
                © {{ currentYear }} ·
                <a href="https://inovanex.com" target="_blank" rel="noopener">INOVANEX.COM</a>
                · Generador Player Radio v3
            </p>
        </footer>
    </div>
</template>

<script>
import FormGenerator from './FormGenerator.vue'
import logoSrc from '@/assets/logo.png'

export default {
  name: 'App',
  components: { FormGenerator },
  data() { return { logoSrc, currentYear: new Date().getFullYear() } }
}
</script>

<style>
html { height: 100%; }
body { margin: 0; }

.bg {
  animation: slide 3s ease-in-out infinite alternate;
  background-image: linear-gradient(-60deg, #ce0011 50%, #000000 50%);
  bottom: 0; left: -50%; right: -50%; top: 0;
  opacity: .5;
  position: fixed;
  z-index: -1;
}
.bg2 { animation-direction: alternate-reverse; animation-duration: 4s; }
.bg3 { animation-duration: 5s; }

@keyframes slide {
  0%   { transform: translateX(-25%); }
  100% { transform: translateX(25%); }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em 3em 3em;
}

.brand-header {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 1.5em;
  padding: 14px 28px;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
}

.brand-logo {
  height: 48px;
  width: auto;
  object-fit: contain;
}

.brand-text { display: flex; flex-direction: column; line-height: 1.15; }

.brand-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.3px;
  font-family: inherit;
}

.brand-version { color: #ce0011; font-weight: 800; }

.brand-by {
  margin: 4px 0 0;
  font-size: 12px;
  color: #555;
  letter-spacing: 0.4px;
}

.brand-by a {
  color: #ce0011;
  text-decoration: none;
  font-weight: 600;
}
.brand-by a:hover { text-decoration: underline; }

.form {
  width: 990px;
  max-width: 100%;
  background-color: #faede3;
  border-radius: 5px;
  padding: 1em;
}

.instrucciones {
  width: 990px;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 10px;
  padding: 12px 22px;
  margin-bottom: 1em;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}
.instrucciones summary {
  cursor: pointer;
  font-weight: 600;
  color: #1a1a1a;
  padding: 6px 0;
  list-style: none;
}
.instrucciones summary::-webkit-details-marker { display: none; }
.instrucciones summary::before {
  content: "▸ ";
  color: #ce0011;
  font-weight: 800;
}
.instrucciones[open] summary::before { content: "▾ "; }
.instrucciones ol {
  margin: 10px 0 4px 0;
  padding-left: 22px;
  color: #333;
  font-size: 14px;
  line-height: 1.55;
}
.instrucciones code {
  background: #f1f1f1;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 13px;
}

.brand-footer {
  margin-top: 1.8em;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}
.brand-footer p {
  margin: 0;
  font-size: 12px;
  color: #444;
  letter-spacing: 0.3px;
  text-align: center;
}
.brand-footer a {
  color: #ce0011;
  text-decoration: none;
  font-weight: 600;
}
.brand-footer a:hover { text-decoration: underline; }

h1 { font-family: monospace; }

@media (max-width: 480px) {
  .content { padding: 1em; }
  .brand-header { padding: 10px 16px; gap: 12px; }
  .brand-logo { height: 38px; }
  .brand-title { font-size: 17px; }
  .brand-by { font-size: 11px; }
  .instrucciones { padding: 10px 14px; }
  .instrucciones ol { font-size: 13px; }
  .brand-footer p { font-size: 11px; }
}
</style>
